

















































































import { Component, Vue } from "vue-property-decorator";
import * as modules from "../../../store/decorator";
import { reject } from "lodash";
import helperFormat from "../../mixins/HelperFormat.vue";

@Component ({})
export default class KnowledgeBase extends Vue {
    
    async mounted() {
        // Check agreement status when component mounts
        await this.checkAgreementStatus()
    }

    async checkAgreementStatus() {
        // Check if user is authenticated first
        if (!this.$auth.check()) {
            return
        }

        // Use cached agreement data from store instead of making API call
        if (!modules.user.agreementDetail.agreementAccepted) {
            this.$router.push({ name: 'agreement' })
            return
        }
    }
}
